import { useState, useEffect } from 'react'
import { projectAuth, projectFirestore } from '../firebase/config'
import { useAuthContext } from './useAuthContext'

export const useLogout = () =>{

    
    const [error, setError] = useState(null)
    const [isCancelled, setIsCancelled] = useState(false)
    const [isPending, setIsPending] = useState(false)
    const {dispatch, user} = useAuthContext()

    const logout = async () => {
        setError(null)
        setIsPending(true)

        // sign the user out

        try {

            // update online status

            const {uid} = user
            
            await projectFirestore.collection('users').doc(uid).update({
                online: false
            })

            await projectAuth.signOut()
            
            // dispatch logout action

            dispatch({type: 'LOGOUT'})

            // update state

            if (!isCancelled){
                setIsPending(false)
                setError(null)
            }
        }
        catch(err){
            if (!isCancelled){
                setIsPending(false)
                console.log(err.message)
                setError(err.message)
            }
        }

    }

    useEffect(() => {
      return () => setIsCancelled(true)
    }, [])
    

    return {logout, error, isPending}
}